var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolDeletedChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 6.6665V14.9998C4.16667 16.8408 5.65905 18.3332 7.5 18.3332H12.5C14.3409 18.3332 15.8333 16.8408 15.8333 14.9998V6.6665M11.6667 9.1665V14.1665M8.33333 9.1665L8.33333 14.1665M13.3333 4.1665L12.1614 2.40867C11.8523 1.94501 11.3319 1.6665 10.7747 1.6665H9.22531C8.66805 1.6665 8.14767 1.94501 7.83856 2.40867L6.66667 4.1665M13.3333 4.1665H6.66667M13.3333 4.1665H17.5M6.66667 4.1665H2.5",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolDeletedChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_deleted_chat.2f0454bca4c59694d20424b5eb76dcd3.svg";